<template>
  <div class="search__default">
    <ul class="search__default__list">
      <li class="search__default__item" v-if="recentKeywords?.length > 0">
        <h3 class="ttl">최근 검색어</h3>
        <ul class="word__list word__list--scroll">
          <li
            class="word__item word__item--scroll pnt"
            v-for="(item, index) in recentKeywords"
            :key="index"
            @click="bindWord(item)"
          >
            {{ item }}
            <i class="i_x_n_g" @click.stop="deleteWord(index)"></i>
          </li>
        </ul>
      </li>

      <li class="search__default__item m16">
        <h3 class="ttl">추천 검색어</h3>
        <RecoKeywords @bind="bindWord" @check-apply="checkApply" />
      </li>

      <!-- <li class="search__default__item m16">
        <h3 class="ttl">퍼스 인기글</h3>
        <ul class="board__list" v-if="hotPostList.length > 0">
          <li
            class="board__item pnt"
            v-for="item in hotPostList"
            :key="item.id"
            @click="goDetail(item.id, item.postType)"
          >
            <div class="txt_wrap">
              <p class="color">{{ isCategory(item.postType) }}</p>
              <span class="new" v-if="isNew(item.createdAt)">
                <img
                  :src="require(`@/assets/front/images/i_new2.svg`)"
                  alt=""
                />
              </span>
              <p class="txt">{{ item.title }}</p>
            </div>
          </li>
        </ul>
      </li> -->
    </ul>
  </div>
</template>
<script>
import RecoKeywords from './RecoKeywords.vue';

import { checkNewPost } from '@common/lib/common/utils';

import {
  mapActions as communityMapActions,
  mapGetters as communityGetters,
} from '@common/store/modules/community';
import * as communityTypes from '@common/store/modules/community/types';

export default {
  name: 'component-search-default',
  description: '검색 페이지 > 검색 기본 페이지',
  components: { RecoKeywords },
  props: {
    recentKeywords: Array,
  },
  created() {
    // 퍼스 인기글
    this.getHotList();
  },
  computed: {
    ...communityGetters({ hotPostList: communityTypes.FETCH_HOT_POST_LIST }),
  },
  methods: {
    ...communityMapActions([communityTypes.FETCH_HOT_POST_LIST]),
    async getHotList() {
      const params = { category: '', type: 'ALL' };
      await this[communityTypes.FETCH_HOT_POST_LIST](params);

      console.log('hotPostList');
      console.log(this.hotPostList);
    },
    bindWord(item) {
      this.$emit('bind-word', item);
    },
    deleteWord(idx) {
      this.$emit('delete-word', idx);
    },
    checkApply(type) {
      this.$emit('check-apply', type);
    },
    goDetail(id, type) {
      if (type === 'BOARD') {
        // 자유게시판
        this.$router.push({
          name: 'Board.Detail',
          params: { id: id, isRead: 'Y' },
        });
      } else {
        // 지식인
        this.$router.push({
          name: 'Knowhow.Detail',
          params: { id: id, isRead: 'Y' },
        });
      }
    },
    isCategory(category) {
      let cate = '';
      switch (category) {
        case 'MOBILE':
          cate = '휴대폰';
          break;
        case 'INTERNET':
          cate = '인터넷';
          break;
        case 'MVNO':
          cate = '알뜰폰';
          break;
        case 'PLAN':
          cate = '요금제';
          break;
        case 'RENTAL':
          cate = '렌탈';
          break;
        case 'STORE':
          cate = '매장';
          break;
        case 'BOARD':
          cate = '자유게시판';
          break;
      }
      return cate;
    },
    isNew(createdAt) {
      return checkNewPost(createdAt);
    },
  },
};
</script>
<style scoped></style>
